export default "/public/dist/img/Acosaservefoto_1.jpg";